import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'resetEnableUpsellByCheckout',
  initialState: true,
  reducers: {
    resetEnableUpsellByCheckout(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { resetEnableUpsellByCheckout } = slice.actions;
export default slice.reducer;
